import { guid } from "@progress/kendo-react-common";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Sidebar from "../common/Sidebar";
import Spinner from "../common/Spinner/spinner";
import * as Toasts from "../common/Toastify";
import {
  loadJobToEdit,
  loadJobToTemplate,
  loadMasterData,
  pushToSummary,
  resetJobOpportunityInfo,
  saveJobInfo,
  setErrorInfo,
  setJobDescription,
  setSaveAPIErrors,
  totalShiftAmountCalculation,
  updateDynamicFormData,
} from "./action";
import Certification from "./certification";
import CovidVaccinated from "./covidVaccinated";
import CreateDynamicJob from "./createDynamicJob";
import Education from "./education";
import EmrehrSystemExperience from "./emrehrSystemExperience";
import "./index.css";
import JobInfo from "./jobInfo";
import JobLocation from "./jobLocation";
import {
  validatDynamicForm,
  validateCertificationInfo,
  validateCovidInfo,
  validateDepsUnits,
  validateEducationInfo,
  validateEMREHRInfo,
  validateJobInfo,
  validateJobType,
  validateLocationInfo,
  validateMedicalSpecialityInfo,
  validateOvetimeAllowed,
  validatePayRateInfo,
  validateShiftInfo,
  validateStartJob,
  validateTemplateInfo,
} from "./jobOpportunityUtils";
import JobType from "./jobType";
import MedicalSpeciality from "./medicalSpeciality";
import { jobOpportunitySelector } from "./selector";
import ShiftInfo from "./shiftInfo";
import {
  setJobEncounterOccurreneUpdateList,
  setSelectedOption,
  setjobMultishiftOccurreneUpdateList,
  setShowCalenderModal
} from "./slice";
import StartJobPost from "./startJobPost";
import TemplateInfo from "./templateInfo";
import AutoRepost from "./autoRepost";
import { RRule } from 'rrule'
import OvertimeAllowed from "./OvertimeAllowed";
import DepsUnits from "./depsUnits";
import { fetchDepsUnits } from "../Login/action";
import PayRate from "./payRate";
import { payRateTypeObj } from '../../helpers/data';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const config = useConfiguration();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routlocation = useLocation();
  const specialitySelectRef = useRef(null)
  const certificationRef = useRef(null)
  const emrehrRef = useRef(null)
  const { postion, acceptableTravelDistance, fromMatchingCandidate,templateId } = routlocation.state || "";
  const {
    jobType,
    startJob,
    location,
    shift,
    jobInfo,
    education,
    medicalSpeciality,
    certification,
    emrEhrSystemExperience,
    covidVaccinationStatus,
    templateInfo,
    errors,
    errorLogs,
    loadJobId,
    masterData,
    selectedOption,
    dropDownJobId,
    formdata,
    distance,
    recursionFlag,
    rrurle,
    rrurleStr,
    jobMultishiftOccurreneUpdateList,
    loadingFlag,
    JobEncounterOccurreneUpdateList,
    jobUnique,
    jobCode,
    selectedAuthUsers,
    isAutoPostAllowed,
    checkMarkup,
    isOvertimeAllowed,
    depsUnits
  } = useSelector(jobOpportunitySelector);

  const payRateType = useSelector((store) => store.jobOpportunity.payRateType);
  const payRateTotalShiftAmount = useSelector((store) => store.jobOpportunity.payRateTotalShiftAmount);
  const payRateOccurrenceAmount = useSelector((store) => store.jobOpportunity.payRateOccurrenceAmount);
  // const JobEncounterOccurreneUpdateList = useSelector(
  //   (state) => state.jobOpportunity.JobEncounterOccurreneUpdateList
  // );
  const [filterJobList, setFilterJobList] = useState({});
  // const jobtypeobj = storage.getItem("jobtypeobj");
  const inputTypes = storage.getItem("inputTypes");
  const commonselctRef = useRef([]);
  const jobOpportunityTopRef = useRef(null);
  const { newPost, fromTemplate, createTemplate, editJobPost } = selectedOption;
  const depsUnitsMaster = useSelector(store => store.login.depsUnitsMaster);

  useEffect(() => {
    if (newPost || fromTemplate || createTemplate || editJobPost) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [newPost, fromTemplate, createTemplate, editJobPost]);
  useEffect(() => {
    dispatch(setSelectedOption({ ...postion }));
  }, []);

  useEffect(() => {
    document.title = "Job Details";
    if (config.baseUrl) {
      if (!login) {
        navigate("/");
      } else {
        if (config.baseUrl) {
          if (!loadJobId && fromMatchingCandidate) {
            resetVal();
            if (postion?.editJobPost) {
              dispatch(setSelectedOption({ ...postion, editJobPost: false, newPost: true }));
            }
          }
          if (masterData?.allJobTypes.length === 1) {
            dispatch(
              loadMasterData(`${config.baseUrl}`, login.employerUniqueId, 2)
            ).then(() => {
              if (loadJobId) {
                dispatch(loadJobToEdit(config.baseUrl, loadJobId)).then(() => {
                   dispatch(totalShiftAmountCalculation())
                })
              }
              if (templateId) {
                dispatch(loadJobToTemplate({baseURL:config.baseUrl,templateId}));
              }
            });
          } else {
            dispatch(
              loadMasterData(`${config.baseUrl}`, login.employerUniqueId, 1)
            ).then(() => {
              if (loadJobId) {
                dispatch(loadJobToEdit(config.baseUrl, loadJobId)).then(() => {
                  dispatch(totalShiftAmountCalculation())
                })
              }
              if (templateId) {
                dispatch(loadJobToTemplate({baseURL:config.baseUrl,templateId}));
              }
            });
          }
        }
        if (config.baseUrl && depsUnitsMaster?.length === 0) {
          dispatch(fetchDepsUnits({ baseUrl: config.baseUrl }))
        }
      }
    }

    return () => {
      dispatch(setShowCalenderModal(false))
    }
  }, [config]);

  useEffect(() => {
    let filterVal = [];
    if (dropDownJobId) {
      filterVal = login.jobTypeFlags.jobTypeList.filter(
        (item) => item.jobTypeId === dropDownJobId
      )[0];

      if (filterVal) {
        setFilterJobList(filterVal);
      }
      //const filterVal1 = filterVal.map(item => item.jobTypeId);
    } else {
      filterVal = login.jobTypeFlags.jobTypeList[0]; // login.jobTypeFlags.jobTypeList.map(item => item.jobTypeId);

      if (filterVal) {
        setFilterJobList(filterVal);
      }
    }
  }, [dropDownJobId]);

  const isErrorExists = (errors) => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      return errorKeys.filter((key) => errors[key] !== undefined).length > 0;
    }
    return false;
  };
  const evaluateSaveType = (selectedOption) => {
    if (selectedOption.newPost) {
      return 1;
    }
    if (selectedOption.fromTemplate) {
      return 2;
    }
    if (selectedOption.createTemplate) {
      return 3;
    }
    return 0;
  };
  const saveJobMatching = () => {
    const navigateToMatchingCandidate = true;
    const saveType = evaluateSaveType(selectedOption);
    dispatch(setSaveAPIErrors("")).then(() => {
      dispatch(
        saveJobInfo(
          `${config.baseUrl}`,
          jobType,
          startJob,
          location,
          shift,
          jobInfo,
          education,
          medicalSpeciality,
          certification,
          emrEhrSystemExperience,
          covidVaccinationStatus,
          templateInfo,
          login.employerId,
          loadJobId,
          navigateToMatchingCandidate,
          saveType,
          filterJobList,
          formdata,
          recursionFlag,
          rrurle,
          jobMultishiftOccurreneUpdateList,
          JobEncounterOccurreneUpdateList,
          jobUnique,
          jobCode,
          isAutoPostAllowed
        )
      )
        .then((response) => {
          if (response?.result > 0) {
            Toasts.success(response?.message);
          } else {
            Toasts.error(response?.message);
          }
        })
        .catch((error) => {
          Toasts.error(error?.message);
          dispatch(setSaveAPIErrors(error.message));
        });
    });
  };

  const reviewAndSubmitDetails = () => {
    let matching;

    let save;
    if (
      selectedOption.newPost ||
      selectedOption.fromTemplate ||
      selectedOption.editJobPost
    ) {
      matching = true;

      save = true;
    } else if (
      postion?.newPost ||
      postion?.fromTemplate ||
      postion?.editJobPost
    ) {
      matching = true;

      save = true;
    }

    dispatch(setJobDescription()).then((description) => {
      const errors = {};
      validateJobType(jobType, errors, masterData);
      validateStartJob(selectedOption, startJob, errors);
      validateLocationInfo(location, errors);
      validatePayRateInfo(payRateType, recursionFlag, payRateTotalShiftAmount, payRateOccurrenceAmount, errors);
      validateShiftInfo(
        shift,
        errors,
        recursionFlag,
        selectedAuthUsers,
        JobEncounterOccurreneUpdateList
      );
      // validateEducationInfo(education, errors);
      validateJobInfo(jobInfo, errors, recursionFlag);
      // if (filterJobList?.showSpecialties) {
      //   validateMedicalSpecialityInfo(medicalSpeciality, errors);
      // }

      // if (filterJobList?.showCertifications) {
      //   validateCertificationInfo(certification, errors);
      // }

      // if (filterJobList?.showEmr) {
      //   validateEMREHRInfo(emrEhrSystemExperience, errors);
      // }

      if (filterJobList?.showQATab) {
        validatDynamicForm(formdata, errors, inputTypes);
      }

      // validateCovidInfo(covidVaccinationStatus, errors);
      validateDepsUnits(depsUnits, errors,);
      validateOvetimeAllowed(isOvertimeAllowed, errors, selectedOption, recursionFlag);
      validateTemplateInfo(templateInfo, errors, selectedOption);
      // if (description === "" || description === "<p><br></p>") {
      //   errors.jobDescription = "Job Description is required";
      // }

      if (
        jobMultishiftOccurreneUpdateList &&
        !jobMultishiftOccurreneUpdateList.length &&
        rrurle &&
        recursionFlag?.toString() === "3" &&
        shift.startTime?.name &&
        shift.endTime?.name
      ) {

        let shiftStartDate = shift.date;
        let shiftEndDdate = shift.date;
        const startTime = moment(shift.startTime?.id, 'hh:mm');
        const endTime = moment(shift.endTime?.id, 'hh:mm');
        const InMinutes = moment.duration(endTime.diff(startTime)).asMinutes();
        if (InMinutes <= 0) {
          shiftEndDdate = moment(shift.date).add(1, 'day').format('YYYY-MM-DD');
        }
        const startDateFormat = moment(
          shiftStartDate + ' ' + shift.startTime.name,
          'YYYY-MM-DD H:mm A'
        );
        const endDateFormat = moment(
          shiftEndDdate + ' ' + shift.endTime.name,
          'YYYY-MM-DD H:mm A'
        );

        const rule1 = RRule.fromString(
          `DTSTART:${moment(new Date(startDateFormat)).utc().format('YYYYMMDDTHHmmss')}Z;
          RRULE:${rrurle}
          `)
        if (!rule1.all()?.length) {
          Toasts.error("Please select the valid days");
          return
        } else {
          const calenderRequestBody = {
            TaskID: guid(),
            ownerID: guid(),
            Title: "Shift Info",
            Description: "",
            StartTimezone: null,
            Start: new Date(startDateFormat),
            End: new Date(endDateFormat),
            EndTimezone: null,
            RecurrenceRule: rrurle,
            RecurrenceID: null,
            RecurrenceException: [],
            isAllDay: false,
            locationId: location.locationNameInfo?.id,
            jobsContactsList: location.contactPersons.map(item => item.id),
            jobsApproversList: location.approvalUsers.map(item => item.id),
            billingrate: jobInfo?.billingrate ? jobInfo?.billingrate : '',
            shiftLength: shift.preferedShift?.id ? shift.preferedShift?.id : '',
            editDay: false,
            payRateOccurrenceAmount: (+payRateType === payRateTypeObj.manualCal) ? payRateOccurrenceAmount : null
          };

          dispatch(
            setjobMultishiftOccurreneUpdateList(
              JSON.parse(JSON.stringify([calenderRequestBody]))
            )
          );
        }
      }

      // if (
      //   JobEncounterOccurreneUpdateList &&
      //   !JobEncounterOccurreneUpdateList.length &&
      //   recursionFlag?.toString() === '4'
      // ) {
      //   const startDateFormat = moment(
      //     shift.date + ' ' + shift.startTime.name,
      //     'YYYY-MM-DD H:mm A'
      //   );
      //   const endDateFormat = moment(
      //     shift.date + ' ' + shift.endTime.name,
      //     'YYYY-MM-DD H:mm A'
      //   );

      //   const calenderRequestBody = {
      //     TaskID: guid(),
      //     ownerID: guid(),
      //     Title: 'Shift Info',
      //     Description: '',
      //     StartTimezone: null,
      //     Start: new Date(startDateFormat),
      //     End: new Date(endDateFormat),
      //     EndTimezone: null,
      //     RecurrenceRule: rrurle,
      //     RecurrenceID: null,
      //     RecurrenceException: [],
      //     isAllDay: false,
      //   };

      //   dispatch(
      //     setjobMultishiftOccurreneUpdateList(
      //       JSON.parse(JSON.stringify([calenderRequestBody]))
      //     )
      //   );
      // }


      if (isErrorExists(errors)) {
        dispatch(setErrorInfo(errors));
        Toasts.error("Please address validation requirements");
      } else {
        // if(parseInt(recursionFlag) === 2 && !selectedOption.createTemplate &&  !postion?.createTemplate ){
        //   saveJobMatching()
        //   return
        // } else {
        if (!checkMarkup?.variableshiftmarkup?.length && recursionFlag?.toString() !== "2") {
          Toasts.error("Please add Variable Markup on Admin portal");
          return
        }

        dispatch(setErrorInfo({}));
        dispatch(
          pushToSummary(
            jobType,
            startJob,
            location,
            shift,
            jobInfo,
            education,
            medicalSpeciality,
            certification,
            emrEhrSystemExperience,
            covidVaccinationStatus,
            templateInfo,
            login.employerUniqueId,
            formdata,
            rrurle,
            recursionFlag,
            rrurleStr,
            JobEncounterOccurreneUpdateList,
            isAutoPostAllowed,
            isOvertimeAllowed,
            depsUnits,
            payRateType,
            payRateTotalShiftAmount,
            payRateOccurrenceAmount
          )
        ).then(() => {
          navigate("/jobsummary", {
            state: {
              gotoMatching: matching,
              save: save,
              acceptableTravelDistance: distance
                ? distance
                : acceptableTravelDistance,
              postion: selectedOption,
            },
          });
        });
        // }
      }
    });
  };

  useEffect(() => {
    // const newVal = JSON.parse(JSON.stringify(formdata));
    // newVal.forEach(item => {
    //   item.controlsInfo.forEach((val, index) => {
    //     commonselctRef?.current[`${item.formId}-${index}`]?.resetSelectedValues();
    //   })
    // });
  }, [selectedOption]);

  const resetVal = () => {
    const newVal = JSON.parse(JSON.stringify(formdata));
    newVal.forEach((item) => {
      item.controlsInfo.forEach((val, index) => {
        // commonselctRef?.current[`${item.formId}-${index}`]?.resetSelectedValues();
      });
    });
    dispatch(updateDynamicFormData(newVal)).then(() => {
      dispatch(resetJobOpportunityInfo());
    });
  };

  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}

      <Header />
      <Sidebar />
      <div className="page-main">
        <div ref={jobOpportunityTopRef} />
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">
                  {selectedOption.newPost
                    ? "Create New Open Shift" :
                    selectedOption.fromTemplate ? "Create Open Shift With Template"
                      : selectedOption.editJobPost
                        ? "Edit Shift"
                        : "Create a template"}
                </h1>
              </div>
              {errorLogs && errorLogs.length > 0 && (
                <>
                  <div
                    className="toast wrap-input100 align-items-center text-white bg-danger border-0 show"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    data-bs-autohide="false"
                  >
                    <div className="d-flex col-6">
                      <div className="toast-body">
                        {errorLogs.join(",") || "Data error! Please try again."}
                      </div>
                    </div>
                  </div>
                  <div>&nbsp;</div>
                </>
              )}
              <div className="row">
                <div className="col-xl-12 col-md-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <JobType errors={errors} />
                        {selectedOption.fromTemplate && (
                          <StartJobPost errors={errors} />
                        )}
                        <JobLocation errors={errors} />
                        <PayRate errors={errors} />
                        <ShiftInfo
                          errors={errors}
                          RecurrenceDisabled={selectedOption.editJobPost}
                          specialitySelectRef={specialitySelectRef}
                          certificationRef={certificationRef}
                          emrehrRef={emrehrRef}
                        />
                        <JobInfo errors={errors}
                          specialitySelectRef={specialitySelectRef}
                          certificationRef={certificationRef}
                          emrehrRef={emrehrRef}

                        />
                        <Education errors={errors} />
                        <div className="row me-0 pe-0">
                          <div
                            className={
                              filterJobList?.showSpecialties
                                ? "col-lg-6 col-md-6 ps-0"
                                : "col-lg-12 col-md-12"
                            }
                          >
                            {filterJobList?.showSpecialties && (
                              <>
                                <MedicalSpeciality
                                  specialitySelectRef={specialitySelectRef}
                                  errors={errors}
                                  checkWidth={
                                    filterJobList?.showSpecialties
                                      ? "col-lg-12"
                                      : "col-lg-6"
                                  }
                                />
                              </>
                            )}
                          </div>
                          <div
                            className={
                              filterJobList?.showCertifications
                                ? "col-lg-6 col-md-6 pe-0"
                                : "col-lg-12 col-md-12 pe-0"
                            }
                          >
                            {filterJobList?.showCertifications && (
                              <>
                                <Certification
                                  certificationRef={certificationRef}
                                  errors={errors}
                                  checkWidth={
                                    filterJobList?.showCertifications
                                      ? "col-lg-12"
                                      : "col-lg-6"
                                  }
                                />
                              </>
                            )}
                          </div>
                        </div>

                        <div className="row me-0 pe-0">
                          <div
                            className={
                              filterJobList?.showEmr
                                ? "col-lg-6 col-md-6 ps-0"
                                : "col-lg-12 col-md-12"
                            }
                          >
                            {filterJobList?.showEmr && (
                              <>
                                <EmrehrSystemExperience
                                  emrehrRef={emrehrRef}
                                  errors={errors}
                                  checkWidth={
                                    filterJobList?.showEmr
                                      ? `col-lg-12 ${editJobPost ? "bottom-drop" : ""
                                      }`
                                      : `col-lg-6 ${editJobPost ? "bottom-drop" : ""
                                      }`
                                  }
                                />
                              </>
                            )}
                          </div>
                          {/* 'col-lg-6 col-md-6 pe-0' */}
                          <div
                            className={
                              filterJobList?.showEmr
                                ? "col-lg-6 col-md-6 pe-0"
                                : "col-lg-12 col-md-12"
                            }
                          >
                            <CovidVaccinated
                              errors={errors}
                              checkWidth={
                                filterJobList?.showEmr
                                  ? `col-lg-12 ${editJobPost ? "bottom-drop" : ""
                                  }`
                                  : `col-lg-6 ${editJobPost ? "bottom-drop" : ""
                                  }`
                              }
                            />
                          </div>
                        </div>

                        {filterJobList?.jobTypeId &&
                          login?.accountFlags?.isShowQATab && (
                            <CreateDynamicJob
                              jobTypeId={filterJobList?.jobTypeId}
                              errors={errors}
                              postion={postion}
                              commonselctRef={commonselctRef}
                            />
                          )}

                        {/* <div className="row me-0 pe-0 mb-4">
                          {(parseInt(recursionFlag) === 1 || parseInt(recursionFlag) === 3) ? <div className={"col-lg-6 col-md-6 ps-0"}>
                            <AutoRepost />
                          </div> : ""}
                          <div className={(parseInt(recursionFlag) === 1 || parseInt(recursionFlag) === 3) ? "col-lg-6 col-md-6 pe-0" : "col-lg-12 col-md-12 "}>
                            <TemplateInfo errors={errors} />
                          </div>
                        </div> */}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", rowGap: "1.25rem", columnGap: "1.75rem" }} className="row">
                          {((parseInt(recursionFlag) === 1 || parseInt(recursionFlag) === 3)) && <AutoRepost />}
                          <DepsUnits errors={errors} />
                          {selectedOption?.createTemplate ? "" : ((parseInt(recursionFlag) !== 2) && <OvertimeAllowed errors={errors} />)}
                          <TemplateInfo errors={errors} />
                        </div>
                        <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                          <div className="me-2" role="group">
                            {/* Only Edit Job Working Cancel Button */}
                            {selectedOption.editJobPost && (
                              <button
                                className="btn btn-outline-primary"
                                style={{ marginRight: "10px" }}
                                type="button"
                                onClick={() => navigate(-1)}
                              >
                                Cancel
                              </button>
                            )}
                            {/* Only New Job Working Reset Button */}
                            {!selectedOption.editJobPost && (
                              <button
                                className="btn btn-outline-primary"
                                style={{ marginRight: "10px" }}
                                type="button"
                                onClick={() => {
                                  resetVal();
                                }}
                              >
                                Reset
                              </button>
                            )}

                            <button
                              className="btn btn-primary sw-btn-next"
                              type="button"
                              onClick={(data) => reviewAndSubmitDetails()}
                            >
                              {/* {(selectedOption.createTemplate === true || parseInt(recursionFlag) !== 2) ? " Review & Submit" : "Assign"} */}
                              Review & Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
